export default __webpack_public_path__ + "static/mamag-news-a4f255a98aa8e08d85c7aefe08303ab3.png";